<template>
  <div class="menu">
    <div class="container">
      <div class="header">
        <BaseText11 class="altcopy" text="Do you have what it<br>takes to stare down<br>a UFC fighter?"/>
      </div>
      <div class="main">
        <router-link to="/selection">
          <BaseTextAnimation1 class="menu-item" ref="play" @click.native.once="createFacebookPixel">
            <BaseText12 text="Play"/>
          </BaseTextAnimation1>
        </router-link>
        <router-link :to="{ name: 'instructions', params: { nextRoute: '/menu' } }" >
          <BaseTextAnimation1 class="menu-item" ref="how-to-play">
            <BaseText12 text="How to play"/>
          </BaseTextAnimation1>
        </router-link>
        <img class="lockup-p3" ref="lockup" src="@/assets/img/lockup-1.svg">
        <router-link to="/leaderboard">
          <BaseTextAnimation1 class="menu-item" ref="leaderboard">
            <BaseText12 text="Leaderboard"/>
          </BaseTextAnimation1>
        </router-link>
        <router-link to="/highscores">
          <BaseTextAnimation1 class="menu-item" ref="results">
            <BaseText12 text="Results"/>
          </BaseTextAnimation1>
        </router-link>
      </div>
      <div class="footer">
        <div class="menu-social">
          <BaseButtonShareFacebook ref="button-fb" :url="$content.shareUrl"/>
          <BaseButtonShareTwitter ref="button-tw" :url="$content.shareUrl"/>
        </div>
        <a class="buy-button" :href="$content.buyUrl" target="_blank"><BaseButtonBuy/></a>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTextAnimation1 from '@/components/BaseTextAnimation1/BaseTextAnimation1'
import BaseText11 from '@/components/BaseText11/BaseText11'
import BaseText12 from '@/components/BaseText12/BaseText12'
import BaseButtonShareFacebook from '@/components/BaseButtonShareFacebook/BaseButtonShareFacebook'
import BaseButtonShareTwitter from '@/components/BaseButtonShareTwitter/BaseButtonShareTwitter'
import BaseButtonBuy from '@/components/BaseButtonBuy/BaseButtonBuy'
import createFacebookPixel from '@/utils/createFacebookPixel'
import { TimelineMax, TweenMax } from 'gsap'
export default {
  components: {
    BaseText11,
    BaseText12,
    BaseTextAnimation1,
    BaseButtonShareFacebook,
    BaseButtonShareTwitter,
    BaseButtonBuy
  },
  mounted () {
    this.tl = this.createTl()
  },
  computed: {
    createFacebookPixel () {
      return createFacebookPixel
    }
  },
  methods: {
    createTl () {
      const tl = new TimelineMax({ paused: true })
      tl.add([
        this.$refs['play'].tl.play(),
        this.$refs['how-to-play'].tl.play(),
        TweenMax.from(this.$refs['lockup'], 0.4, { autoAlpha: 0, xPercent: 10 }),
        this.$refs['leaderboard'].tl.play(),
        this.$refs['results'].tl.play(),
        TweenMax.from(this.$refs['button-fb'].$el, 0.8, { autoAlpha: 0, xPercent: 10 }),
        TweenMax.from(this.$refs['button-tw'].$el, 0.8, { autoAlpha: 0, xPercent: 10 })
      ], 0.5, 'start', 0.1)
      return tl
    },
    animateIn () {
      this.tl.play()
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  min-width: 1200px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  * { text-align: left };
  > * { width: 100% };
}
.container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  > * {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
  }
}
.altcopy {
  font-size: 2.75rem;
  line-height: 2.5rem;
}
.main {
  height: auto;
  justify-content: space-around;
}
.lockup-p3 {
  position: relative;
  width: auto;
  height: 2.5rem;
}
.menu-item {
  transform: skewX(-10deg);
  cursor: pointer;
}
::v-deep .menu-item * {
  font-size: 2.5rem;
  white-space: nowrap;
}
.menu-social {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  > *:not(:last-child) {
    margin-right: 2rem;
  }
}
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.buy-button {
  position: absolute;
  width: 15rem;
  right: 0;
  bottom: 0;
}
</style>
